// English texts of the "routines" area. Keys start with "routines."
export default {
  "routines.title": "Routines",
  "routines.newRoutine": "New routine",
  "routines.editRoutine": "Edit routine",
  // Short day count: timers ("1d 02:00:00"), postpone buttons, worked-days badges.
  "routines.daysShort": "{n}d",
  "routines.date.anytime": "Anytime",

  // Repeat rules (engine/core/recurrence.js). Interval 1 has its own text; {count} is 2 or more.
  "routines.schedule.whenever": "Whenever you choose",
  "routines.schedule.daily": "Every day",
  "routines.schedule.weekly": "Every week",
  "routines.schedule.monthly": "Every month",
  "routines.schedule.yearly": "Every year",
  "routines.schedule.days_other": "Every {count} days",
  "routines.schedule.weeks_other": "Every {count} weeks",
  "routines.schedule.months_other": "Every {count} months",
  "routines.schedule.years_other": "Every {count} years",
  "routines.schedule.dailyAfter": "Every day after completion",
  "routines.schedule.weeklyAfter": "Every week after completion",
  "routines.schedule.monthlyAfter": "Every month after completion",
  "routines.schedule.yearlyAfter": "Every year after completion",
  "routines.schedule.daysAfter_other": "Every {count} days after completion",
  "routines.schedule.weeksAfter_other": "Every {count} weeks after completion",
  "routines.schedule.monthsAfter_other": "Every {count} months after completion",
  "routines.schedule.yearsAfter_other": "Every {count} years after completion",
  // Between weekday names: "Mon, Wed, Fri".
  "routines.schedule.daySeparator": ", ",
  "routines.schedule.next": "Next: {date}",

  // Status and actions
  "routines.status.archived": "Archived",
  "routines.status.paused": "Paused",
  "routines.status.inProgress": "In progress",
  "routines.status.reviewEdits": "Review edits",
  "routines.action.resume": "Resume",
  "routines.action.resumeNamed": "Resume: {name}",
  "routines.action.start": "Start",
  "routines.action.startNamed": "Start: {name}",
  "routines.action.markDone": "Mark done",
  "routines.action.markDoneNamed": "Mark done: {name}",
  "routines.action.resumeSession": "Resume session",
  "routines.action.startSession": "Start session",
  "routines.action.completeEarly": "Complete early",

  // Badge on map nodes, side panel
  "routines.badge.routine": "Routine · {schedule}",
  "routines.badge.task": "Repeating task · {schedule}",
  "routines.badge.open": "Open routine",
  "routines.panel.openNotes": "Open Notes (N)",
  "routines.panel.closeNotes": "Close Notes (N)",
  "routines.panel.openRoutines": "Open Routines (R)",
  "routines.panel.closeRoutines": "Close Routines (R)",
  "routines.panel.sidePanels": "Side panels",
  "routines.panel.details": "Routine details",
  "routines.panel.resize": "Resize routines panel",

  // Picker (Shift+R on a node)
  "routines.picker.title": "Add to routine",
  "routines.picker.intro": "Add {name} to…",
  "routines.picker.newRoutine": "+ New routine",

  // Due routines (Dashboard, notes)
  "routines.due.completed": "Completed",
  "routines.due.inList": "In this list",
  "routines.due.remove": "Remove from this note",

  // Library
  "routines.library.browse": "Browse",
  "routines.library.hideAll": "Hide routines",
  "routines.library.browseAll": "Browse routines",
  "routines.library.new": "+ New",
  "routines.library.close": "Close routines",
  "routines.library.find": "Find a routine",
  "routines.library.findPlaceholder": "Find a routine…",
  "routines.library.filter": "Filter routines",
  "routines.library.noMatch": "No matching routines.",
  "routines.library.empty": "Repeating tasks and routines will appear here.",
  "routines.filter.all": "All routines",
  "routines.filter.due": "Due now",

  // Date preview in the editor
  // English writes the rule in lower case here ("then every day after completion").
  "routines.preview.completion": "First due {date}; then {rule}.",
  "routines.preview.none": "No upcoming dates in this rule.",
  "routines.preview.incomplete": "Complete the repeat settings to preview the dates.",

  // Editor
  "routines.editor.back": "← Back",
  "routines.editor.namePlaceholder": "What do you want to repeat?",
  "routines.editor.repeat": "Repeat",
  "routines.editor.whenever": "Whenever I choose",
  "routines.editor.onSchedule": "On a schedule",
  "routines.editor.afterCompletion": "After completion",
  // Label before the interval field and its unit: "Every [2] [weeks]".
  "routines.editor.every": "Every",
  "routines.editor.interval": "Repeat interval",
  "routines.editor.unit": "Repeat unit",
  "routines.unit.days": "days",
  "routines.unit.weeks": "weeks",
  "routines.unit.months": "months",
  "routines.unit.years": "years",
  "routines.editor.repeatOn": "Repeat on",
  "routines.editor.allowedDays": "Allowed days",
  "routines.editor.allowedHint": "Dates on excluded days move to the next allowed day.",
  "routines.editor.dateOptions": "Dates & repeat options",
  "routines.editor.firstDate": "First date",
  "routines.editor.endDate": "End date · optional",
  "routines.editor.missed": "If not completed",
  "routines.editor.missedContinue": "Continue with the next date",
  "routines.editor.missedKeep": "Keep outstanding dates",
  "routines.editor.monthEnd": "Month end",
  "routines.editor.monthEndClamp": "Use the last available day",
  "routines.editor.monthEndLast": "Always the last day",
  "routines.editor.monthEndSkip": "Skip months without that date",
  "routines.editor.timeZone": "Time zone: {zone}",
  "routines.editor.context": "Context · optional",
  "routines.editor.cue": "When or where",
  "routines.editor.cuePlaceholder": "e.g. after lunch or before leaving",
  "routines.editor.steps": "Steps",
  "routines.editor.optional": "optional",
  "routines.editor.addChildren_one": "Add {count} child task",
  "routines.editor.addChildren_other": "Add {count} child tasks",
  "routines.editor.stepsHint": "Leave empty to repeat this task on its own.",
  "routines.editor.reorderHint": "Drag to reorder, or use Alt + ↑ / ↓",
  "routines.editor.newTask": "New task",
  "routines.editor.hideStep": "Hide step details",
  "routines.editor.editStep": "Edit step details",
  "routines.editor.removeStep": "Remove step",
  "routines.editor.taskName": "Task name",
  "routines.editor.duration": "Duration",
  "routines.editor.durationUnit": "Duration unit",
  "routines.durationUnit.minutes": "min",
  "routines.durationUnit.hours": "hours",
  "routines.durationUnit.days": "days",
  "routines.editor.goal": "Goal",
  "routines.editor.goalPlaceholder": "What would you like to accomplish?",
  // {keys} is "Shift + R" as keyboard keys.
  "routines.editor.shortcutHint": "{keys} over a map node adds it here.",
  "routines.editor.childTasks": "Child tasks",
  "routines.editor.addAsStep": "Add {name} as a step",
  "routines.editor.inRoutine": "In routine",
  "routines.editor.addStep": "Add a step",
  "routines.editor.addStepPlaceholder": "Add a step: find a task or type a new one…",
  "routines.editor.tasksToAdd": "Tasks to add",
  "routines.editor.create": "Create “{name}”",
  // {branch} is the name of the branch that receives new tasks ("Unsorted").
  "routines.editor.newTaskIn": "New task in {branch}",
  "routines.editor.mapRoot": "Map root",
  "routines.editor.pickerEmpty": "Type a name to create your first step.",

  // Concurrent edits
  "routines.conflict.title": "Review edits from another device",
  "routines.conflict.intro": "Your draft is below. These saved versions are retained in history.",
  "routines.conflict.keep": "I reviewed these versions; keep my draft",
  "routines.conflict.notice": "This routine was edited on two devices. Open Edit to review both versions.",
  "routines.anchor.title": "Choose the completion date",
  "routines.anchor.text": "Two devices recorded different dates ({dates}). Both records are kept. Choose the date for the next repeat.",
  "routines.anchor.use": "Use this date",

  // Overview
  "routines.welcome.title": "Make it a routine.",
  "routines.welcome.text": "Repeat a single task, or build a checklist to use again.",
  "routines.welcome.create": "Create a routine",
  "routines.overview.eyebrowRoutine": "ROUTINE",
  "routines.overview.eyebrowTask": "REPEATING TASK",
  "routines.overview.dateReview": "Date needs review",
  "routines.overview.ended": "Schedule ended",
  // English has always shown "1 steps": no one-form in English (other languages have theirs).
  "routines.overview.steps_one": "{count} step",
  "routines.overview.steps_other": "{count} steps",
  "routines.overview.planned": "{duration} planned",
  "routines.overview.resumeSummary": "{done} of {total} steps saved · {date}",
  "routines.overview.historySummary_one": "{done} completed · {minutes} min recorded · {count} activity day",
  "routines.overview.historySummary_other": "{done} completed · {minutes} min recorded · {count} activity days",
  "routines.more.resumeSchedule": "Resume schedule",
  "routines.more.pauseSchedule": "Pause schedule",
  "routines.more.restore": "Restore routine",
  "routines.more.archive": "Archive routine",
  "routines.more.moveDate": "Move next date",
  "routines.more.move": "Move",
  "routines.more.skip": "Skip this time",

  // Session runner
  "routines.run.started": "Started {date}",
  "routines.run.recorded": "Recorded {date}",
  "routines.run.completed": "Completed",
  "routines.run.stopped": "Stopped",
  "routines.run.reopen": "Reopen to correct",
  "routines.run.continue": "Continue session",
  // {time} is the running clock.
  "routines.run.elapsed": "Elapsed {time}",
  "routines.run.progress": "{done} of {total} steps complete",
  "routines.run.progressLabel": "Session completion",
  "routines.run.uncheck": "Uncheck {name}",
  "routines.run.complete": "Complete {name}",
  "routines.run.hideDetails": "Hide details: {name}",
  "routines.run.showDetails": "Show details: {name}",
  "routines.run.instructions": "Instructions",
  "routines.run.pause": "Pause",
  "routines.run.startTimer": "Start timer",
  "routines.run.recordedLog": "Recorded time & note",
  "routines.run.recordLog": "Record time or a note",
  "routines.run.recordedUnit": "Recorded duration unit",
  "routines.run.note": "Note",
  "routines.run.notePlaceholder": "Progress, outcome, or anything to remember",
  "routines.run.completeStep": "Complete step",
  "routines.run.doneNext": "Done & next",
  "routines.footer.pending": "Changes pending · Applies to future sessions",
  "routines.footer.saved": "Saved automatically · Applies to future sessions",
  "routines.footer.saving": "Saving… · Applies to future sessions",
  "routines.footer.allDone": "All steps complete",
  "routines.footer.continues": "Continues when you leave",
  "routines.footer.finish": "Finish session",
  "routines.footer.stop": "Stop session",

  // History
  "routines.history.button": "History",
  "routines.history.eyebrow": "HISTORY",
  "routines.history.intro": "Each session keeps the steps and goals used at the time.",
  "routines.history.back": "← Routine",
  "routines.history.version": "Routine version",
  "routines.history.allVersions": "All versions",
  "routines.history.versionItem": "Version {n} · {date}",
  "routines.history.completed": "completed",
  "routines.history.minutes": "minutes recorded",
  // Under a number of days.
  "routines.history.activityDays_one": "activity day",
  "routines.history.activityDays_other": "activity days",
  "routines.history.runSummary": "{done} / {total} steps · {minutes} min",
  "routines.history.partial": "Partial",
  "routines.history.empty": "Your first session will appear here.",
  "routines.history.schedule": "Schedule history",
  "routines.history.skipped": "Skipped · {date}",
  "routines.history.moved": "Moved · {date} → {to}",
  // English has always shown "1 recent dates": no one-form in English (other languages have theirs).
  "routines.history.unlogged_one": "{count} recent date without a recorded session",
  "routines.history.unlogged_other": "{count} recent dates without a recorded session",
  "routines.history.unloggedDates": "{dates}. “Not logged” does not mean you did no work.",
  "routines.history.clean": "No skipped or unlogged dates in the recent schedule.",

  // Unsaved work
  "routines.pending.draft": "Unsaved edits: {name}",
  "routines.pending.review": "Review",
  "routines.pending.session": "Session edits pending",
  "routines.pending.save": "Save pending edits",
  "routines.timer.paused": "Timer paused · {name}",
  "routines.timer.recordedHere": "{time} recorded here. {error} Your unsaved time is kept in this tab.",
  "routines.timer.retry": "Retry save",
  "routines.timer.merge": "Add {time} unsaved time to saved minutes",
  "routines.invalidRecords": "Some routine records could not be read. They are preserved in map exports. Keep a backup before repairing this map.",
  "routines.notice.taskDone": "Completed. This task will be available again for its next repeat.",
  "routines.notice.completedToast": "{name} completed",
  "routines.notice.sessionDone": "Session completed.",
  "routines.notice.progressSaved": "Progress saved. Resume whenever you’re ready.",

  // Errors shown in the routine panel
  "routines.error.firstDate": "Choose a valid first date.",
  "routines.error.interval": "Repeat interval must be between 1 and 1000.",
  "routines.error.unit": "Choose a repeat unit.",
  "routines.error.until": "End date must follow the first date.",
  "routines.error.timeZone": "Invalid time zone.",
  "routines.error.allowedDay": "Choose at least one allowed weekday.",
  "routines.error.weekday": "Choose at least one weekday.",
  "routines.error.timerOtherMap": "Open the original map to save this timer.",
  "routines.error.timerTooLong": "This timer exceeds 3660 days. Its start time is retained; adjust the duration before continuing.",
  "routines.error.timerPending": "Save the pending timer below before starting another.",
  "routines.error.timerResume": "Resume this session before starting a timer.",
  "routines.error.timerMerge": "Resume this session and pause its saved timer before adding the unsaved time.",
  "routines.error.historyRepair": "Routine history needs repair before another event can be recorded. Export the map to retain its history.",
  "routines.error.invalidHistory": "Invalid routine history.",
  "routines.error.invalidRecord": "Invalid routine record; keep the original import.",
  "routines.error.conflictingIds": "Conflicting routine record IDs; import into a separate map.",
  "routines.error.otherMap": "The routine must belong to this map.",
  "routines.error.reviewVersions": "Review the concurrent versions before saving a combined routine.",
  "routines.error.changedElsewhere": "This routine changed on another device. Your draft is kept; review the new version before saving.",
  "routines.error.foreignTasks": "Choose tasks from this map. Missing tasks already in a routine keep their saved content.",
  "routines.error.duration": "Choose a duration between 0 and 3660 days.",
  "routines.error.stepIdentity": "Each routine step needs its own identity.",
  "routines.error.resolveBeforeStart": "Resolve or resume this routine before starting.",
  "routines.error.scheduleEnded": "This schedule has ended.",
  "routines.error.invalidOccurrence": "Invalid occurrence.",
  "routines.error.otherSchedule": "This occurrence belongs to another schedule. Open the routine to choose a date.",
  "routines.error.alreadyCompleted": "This occurrence is already completed. Open its history to correct it.",
  "routines.error.reviewTimer": "Review the saved timer before completing this routine.",
  "routines.error.saveSessionFirst": "Save the pending session edits before changing its completion.",
  "routines.error.readOnly": "This map is read-only or has changed.",
  "routines.error.durationInvalid": "Enter a valid duration.",
  "routines.error.pauseBeforeEdit": "Pause this step timer before changing its minutes.",
  "routines.error.sessionGone": "This session is no longer available.",
  "routines.error.completedElsewhere": "This session was completed elsewhere. Open History to review or correct it.",
  "routines.error.timerBeforeDone": "Save the paused timer before marking this step done.",
  "routines.error.reviewConflict": "Review the conflicting edits first.",
  "routines.error.timerBeforeFinish": "Save the paused timer before finishing this session.",
  "routines.error.nameRequired": "Add a name to save this routine.",
  "routines.error.taskName": "Give each new task a name.",
  "routines.error.cannotCreate": "Cannot create tasks in this map.",
  "routines.error.taskRenamed": "A new task was already saved with another name. Rename that task in the map before retrying.",
  "routines.error.draftKept": "{message} Unsaved edits are kept in this tab.",
  "routines.error.returnDate": "Choose a valid return date",

  // Task list rows (notes and mobile)
  "routines.list.undoCompletion": "Undo completion: {name}",
  "routines.list.reorder": "Reorder {name}",
  "routines.list.reorderHint": "Drag to reorder, or use Up/Down arrows when focused",
  "routines.list.focusTask": "Focus task",
  "routines.list.renameTask": "Rename task",
  "routines.list.reviewRoutine": "Review routine",
  "routines.list.repeatSettings": "Repeat settings",
  "routines.list.repeatSettingsFor": "Repeat settings for {name}",
  "routines.list.takeOff": "Take off the list",
  "routines.list.titleSaveFailed": "Could not save the title. Try again, or press Escape to cancel.",
  "routines.list.missingNode": "(missing node)",
  "routines.list.taskTitle": "Task title",

  // List of tasks in a note
  "routines.today.title": "List of tasks",
  // {branch} is the name of the branch that receives new tasks ("Unsorted").
  "routines.today.addHelp": "Hover over a task and press W to add it, or enter a new task name above (created under “{branch}”).",
  "routines.today.newTask": "New task name",
  "routines.today.newTaskPlaceholder": "New task name… (under “{branch}”)",
  "routines.today.empty": "Nothing on this list.",
  "routines.today.markWorked": "Mark as worked on in this note",
  "routines.today.markWorkedDay": "Mark as worked on in this note (counts for {day})",
  "routines.today.worked": "Worked on it in this note",
  "routines.today.workedClear": "Worked on it in this note. Click to clear these work marks.",
  "routines.today.current": "Current ({n})",
  "routines.today.postponed": "Postponed ({n})",
  "routines.today.completed": "Completed ({n})",
  "routines.today.daysWorked": "Days worked on",
  "routines.today.estimate": "Estimate",
  "routines.today.overrun": "Worked days beyond the estimate",
  "routines.today.carried": "Periods carried without working on it",
  "routines.today.returns": "Returns {date}",
  "routines.today.pinned": "Pinned — carried over automatically",
  "routines.today.pin": "Pin: carry over automatically until done",
  "routines.today.pinnedBadge": "Pinned",
  "routines.today.carryOver": "Carry over ({n})",
  "routines.today.carryHint": "Bring unfinished items from the previous period",
  "routines.today.carrySelected": "Carry selected",

  // Postponing a task
  "routines.postpone.title": "Postpone task",
  "routines.postpone.intro": "Keep this task in Postponed as a reminder until the chosen day, then move it to Current. Planned dates stay unchanged.",
  // {date} is shown in bold.
  "routines.postpone.currently": "Currently postponed until {date}.",
  "routines.postpone.until": "Postponed until {date}",
  "routines.postpone.orDate": "Or choose a date",
  "routines.postpone.submit": "Postpone",
  "routines.postpone.bringBack": "Bring back now",
  "routines.postpone.otherMap": "Return to the original map first.",
};
